export const tenantsArray = ['101: Floyd Miles', '102: Annette Black', '103: Darrell Steward', '104: Cameron Williamson', '105: Albert Flores', '106: Esther Howard'];
export const buildingTenantsArray = [{
  address: '8558 Green Rd.',
  tenants: ['101: Floyd Miles', '102: Annette Black', '103: Darrell Steward', '104: Cameron Williamson', '105: Albert Flores', '106: Esther Howard']
}, {
  address: '7529 E. Pecan St.',
  tenants: ['101: Floyd Miles', '102: Annette Black', '103: Darrell Steward', '104: Cameron Williamson', '105: Albert Flores', '106: Esther Howard']
}, {
  address: '775 Rolling Green Rd.',
  tenants: ['101: Floyd Miles', '102: Annette Black', '103: Darrell Steward', '104: Cameron Williamson', '105: Albert Flores', '106: Esther Howard']
}];
export const charges = [{
  tenant: 'Wade Warren',
  type: 'Change occupancy',
  time: 'Dec 30, 2020 07:52',
  appliedTo: '5 tenants',
  overview: '0 → 1'
}, {
  tenant: 'Wade Warren',
  type: 'Uploaded a bill',
  time: 'Dec 29, 2020 05:18',
  appliedTo: 'Water utility',
  overview: 'Filename.pdf'
}, {
  tenant: 'Wade Warren',
  type: 'Uploaded a bill',
  time: 'Dec 21, 2020 23:26',
  appliedTo: '15 residents',
  overview: 'Post $90.00 per tenant on 01/01/2021'
}, {
  tenant: 'Wade Warren',
  type: 'Change occupancy',
  time: 'Dec 20, 2020 21:42',
  appliedTo: '5 residents',
  overview: '1 → 2'
}, {
  tenant: 'Wade Warren',
  type: 'Change occupancy',
  time: 'Dec 18, 2020 23:14',
  appliedTo: '5 residents',
  overview: '1 → 2'
}, {
  tenant: 'Wade Warren',
  type: 'Move-in',
  time: 'Dec 17, 2020 19:28',
  appliedTo: '1 resident',
  overview: 'Jerome Bell moves in on 01/01/2021'
}, {
  tenant: 'Wade Warren',
  type: 'Change occupancy',
  time: 'Dec 16, 2020 07:52',
  appliedTo: '5 residents',
  overview: '1 → 4'
}, {
  tenant: 'Wade Warren',
  type: 'Change occupancy',
  time: 'Dec 16, 2020 05:18',
  appliedTo: '5 residents',
  overview: '2 → 3'
}, {
  tenant: 'Wade Warren',
  type: 'Change occupancy',
  time: 'Dec 7, 2020 23:26',
  appliedTo: '5 residents',
  overview: '1 → 2'
}];
export const teammates = ['Bessie Cooper', 'Brooklyn Simmons', 'Eleanor Pena', 'Ralph Edwards', 'Darrell Steward', 'Robert Fox', 'Darlene Robertson', 'Marvin McKinney', 'Kristin Watson', 'Jacob Jones'];